import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <span className="w-10 h-10 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                理论电影
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              专注于影视理论探讨和电影评论，涵盖电影分析、影视文化研究及相关资讯，帮助用户深入理解电影艺术与理论。
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="mailto:contact@theoryfilm.cn"
                aria-label="官方邮箱"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-800 hover:bg-accent-500 hover:text-primary-950 transition-colors"
              >
                <i className="ri-mail-line text-lg" />
              </a>
              <a
                href="https://weibo.com"
                target="_blank"
                rel="noreferrer"
                aria-label="微博"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-800 hover:bg-accent-500 hover:text-primary-950 transition-colors"
              >
                <i className="ri-weibo-line text-lg" />
              </a>
              <a
                href="https://www.douban.com"
                target="_blank"
                rel="noreferrer"
                aria-label="豆瓣"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-800 hover:bg-accent-500 hover:text-primary-950 transition-colors"
              >
                <i className="ri-douban-line text-lg" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="font-heading text-sm font-semibold tracking-widest text-accent-400 mb-5">
              内容分类
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/category/theory" className="text-background-200 hover:text-background-50 transition-colors">
                  影视理论
                </Link>
              </li>
              <li>
                <Link to="/category/review" className="text-background-200 hover:text-background-50 transition-colors">
                  电影评论
                </Link>
              </li>
              <li>
                <Link to="/category/culture" className="text-background-200 hover:text-background-50 transition-colors">
                  影视文化与研究
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-200 hover:text-background-50 transition-colors">
                  全文搜索
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold tracking-widest text-accent-400 mb-5">
              关于本站
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-background-200 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-background-200 hover:text-background-50 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="mailto:contact@theoryfilm.cn" className="text-background-200 hover:text-background-50 transition-colors">
                  contact@theoryfilm.cn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 理论电影 版权所有 · 内容仅供学习与交流使用</p>
          <p>本站为影视理论与电影评论内容平台演示</p>
        </div>
      </div>
    </footer>
  );
}